/** Gateway purchase drafts use fiat source USD; wallet funding retains the user currency. */
export const directPurchaseFiat = { currency: 'USD', decimals: 2 };
